export default __webpack_public_path__ + "static/media/product_details.833ba1e8.png";